import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import config from '../../config'

import { fstmtGraphChangeYear, fstmtChangeDataTableActive, fstmtChangeCurrentStandard } from './actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'id', null)
    const module = _.get(hocProps, 'module', null)
    const customDataPath = ['ui', 'workspace', module, id, 'blocks', 'fstmt', 'customData']
    const authorizationCustomPath = ['authorization', 'accessRights', module, 'custom']

    let showBanner = null
    if (module === config.modules.report.key) {
        const reportRibbonLevel = state.getIn(['ui', 'modules', module, 'ribbon', 'reports', 'active'])
        showBanner = state.getIn([
            ...authorizationCustomPath,
            'reports',
            reportRibbonLevel,
            'blocks',
            'fstmt',
            'parameters',
            'banner',
        ])
    }

    return {
        // Summary
        assets: state.getIn([...customDataPath, 'summary', 'assets', 'data']),
        assetsYear: state.getIn([...customDataPath, 'summary', 'assets', 'year']),
        assetsShowDataTable: state.getIn([...customDataPath, 'summary', 'assets', 'showDataTable']),
        liabilities: state.getIn([...customDataPath, 'summary', 'liabilities', 'data']),
        liabilitiesYear: state.getIn([...customDataPath, 'summary', 'liabilities', 'year']),
        liabilitiesShowDataTable: state.getIn([...customDataPath, 'summary', 'liabilities', 'showDataTable']),
        // Results
        results: state.getIn([...customDataPath, 'results'], {}),
        // Cashflow
        cashFlow: state.getIn([...customDataPath, 'cashFlow'], {}),
        showBanner,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fstmtGraphChangeYear,
            fstmtChangeDataTableActive,
            fstmtChangeCurrentStandard,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
